import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Header.css";

export default function Header() {
  const [scrolled, setScrolled] = React.useState(false);

  const handleScroll = () => {
    const offset = window.scrollY;
    if (offset > 30) {
      setScrolled(true);
    } else {
      setScrolled(false);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
  });

  let navbarClasses = ["header_area"];
  if (scrolled) {
    navbarClasses.push("navbar_fixed");
  }

  const location = useLocation();

  return (
    <header className={navbarClasses.join(" ")}>
      <nav className="navbar navbar-expand-lg navbar-light">
        <div className="container">
          <Link className="navbar-brand logo_h" to="/">
            <img src="/image/FsmLogo.png" alt="FSM" />
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          <div
            className="collapse navbar-collapse offset"
            id="navbarSupportedContent"
          >
            <ul className="nav navbar-nav menu_nav ml-auto">
              <li
                className={
                  location.pathname === "/" ? "nav-item active" : "nav-item"
                }
              >
                <Link to="/" className="nav-link">
                  Home
                </Link>
              </li>

              <li
                className={
                  location.pathname === "/events"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <Link to="/events" className="nav-link">
                  Events
                </Link>
              </li>

              <li
                className={
                  location.pathname === "/gallery"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <Link to="/gallery" className="nav-link">
                  Gallery
                </Link>
              </li>

              <li
                className={
                  location.pathname === "/livestream"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <Link to="/livestream" className="nav-link">
                  Live Stream
                </Link>
              </li>

              <li
                className={
                  location.pathname === "/album"
                    ? "nav-item active"
                    : "nav-item"
                }
              >
                <Link to="/album" className="nav-link">
                  Music
                </Link>
              </li>

              <li className="nav-item submenu dropdown">
                <Link
                  to="#"
                  className="nav-link"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Project Arm
                </Link>

                <ul className="dropdown-menu">
                  <li className="nav-item">
                    <Link to="/christianmission" className="nav-link">
                      Christian Mission
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/theexplorer" className="nav-link">
                      The Explorer
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/missioncommunication" className="nav-link">
                      Communication
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/theovercomers" className="nav-link">
                      The Overcomers
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/blessedgeneration" className="nav-link">
                      Blessed Generation
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/goodsamaritans" className="nav-link">
                      Good Samaritans
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/jehoshaphatarmy" className="nav-link">
                      Jehoshaphat Army
                    </Link>
                  </li>
                </ul>
              </li>

              <li
                className={
                  location.pathname === "/blog" ? "nav-item active" : "nav-item"
                }
              >
                <Link to="/blog" className="nav-link">
                  Blog
                </Link>
              </li>

              <li className="nav-item submenu dropdown">
                <Link
                  to="#"
                  className="nav-link"
                  data-toggle="dropdown"
                  role="button"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  About Us
                </Link>

                <ul className="dropdown-menu">
                  <li className="nav-item">
                    <Link to="/about" className="nav-link">
                      About
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link to="/staff" className="nav-link">
                      Staff
                    </Link>
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}